/**
 * AnswerModel is actually quite simple:
 * we're only interested in the relationship between option ID's and 
 * values: true | false | text
 * An actual answer consists of a AskId, and a sequence of OptionID's and these
 * values.
 */
export class AnswerModel {
	constructor(pollModel, askId) {
		this.answer = {};
		this.listeners = [];
		this.poll = pollModel;
		this.askId = askId;
		this.questions = {};
		this.optionTypes = {};
		this.poll.questions.map( q => {
			this.questions[q.id] = q;
			q.options.map( o=>this.optionTypes[o.id] = q.qtype)
		});
		console.log(`this.optionTypes = `, this.optionTypes);
		this.meta = {}
	}
	setMeta(k,v) {
		this.meta[k] = v;
	}
	addListener(l) {
		this.listeners.push(l);
	}
	removeListener(l) {
		this.listeners = this.listeners.filter(m => l!=m);
	}
	setOption(questionId, optionId, value) {
		// find the question and check whether 
		let q = this.questions[questionId];
		// If a single-select is being set true, all the other
		// single-selection options must be set false.
		if (q.isSingleSelectType() && value) {
			q.options.map( 
				o => {
					let nv = (o.id==optionId);
					if (this.answer[o.id] != nv) {
						this.answer[o.id] = nv;
						this.listeners.map( 
							l=>l.answer_option_changed(o.id, this.answer[o.id] ));
					}
				});
		} else {
			this.answer[optionId] = value;
			this.listeners.map( l=>l.answer_option_changed(optionId, value));
		}
	}
	getOption(optionId) {
		return this.answer[optionId];
	}
	isComplete() {
		for (const qid in this.questions) {
			let q = this.questions[qid];
			if (q.isSingleSelectType()){
				let qo = q.options;

				let qids = qo.map(o => 1*o.id);
				let found = false;
				for (let k in this.answer) {
					let ki = 1*k; // ensure integer 
					let v = this.answer[ki];
					if (false!==v && qids.indexOf(ki) > -1) {
						found = true;
						break;
					}
				}
				if (!found){
					return false;
				}
		
			}			
		}
		return true;
	}
	object() {
		let arr = [];
		for (let k in this.answer) {
			let v = this.answer[k];
			if (false!==v) {
				// find out whether we have a value or a text based on qtype
				arr.push( {id:parseInt(k), value: this.answer[k], qtype: this.optionTypes[k] } );
			}
		}
		return {
			ask_id: parseInt(this.askId),
			meta: this.meta,
			answer: arr
		}
	}
}